exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#channels-temporal-tooltip .tooltip-inner {\n  max-width: none;\n  text-align: left; }\n", ""]);

